import { useLoaderData } from "react-router-dom";
import customFetch from "../utils/axios";
import useDocumentTitle from "../hooks/useDocumentTitle";
import useSanitize from "../hooks/useSanitize";
import HeroBanner from "../components/HeroBanner";
import Export from "../components/Export";

const AboutusPage = () => {
	const { heroBanner, pageTitle, pageData } = useLoaderData();
	useDocumentTitle(`${pageTitle} - QAnC`);
	const setsanitiseCall = useSanitize();
	return (
		<>
			<HeroBanner heroBanner={heroBanner} pageTitle={pageTitle} />
			<section className='site-main  main-container no-sidebar'>
				<div className='container'>
					<div className='row'>
						<div className='page_subtitle'>{pageData.section_title}</div>
						{setsanitiseCall(pageData.section_info)}
					</div>
				</div>
				<Export />
			</section>
		</>
	);
};

export default AboutusPage;

// fetch aboutus page data using loader
export const loader = async () => {
	const response = await customFetch.get(`about-us.json`);
	const { hero_banner, page_title, page_data } = await response.data;
	return {
		heroBanner: hero_banner,
		pageTitle: page_title,
		pageData: page_data,
	};
};
